import React from 'react';
import Footer from "../components/Footer";
import BottomSection from "../components/BottomSection";
import firstImg from "../assets/images/Explorer/first_explorer.png";
import '../style/Explorer.scss';
function Explorer(props) {
  return (
      <div id={'Explorer'}>
        <div className="content-wrapper">
          <div className="landing-content-wrapper">
            <div className="first-section-wrapper">
              <div className="first-title-wrapper">VISUALIZE, AND ANALYZE THE INTERCHAIN WITH TOP BLOCK EXPLORERS</div>
              <div className="first-description-wrapper">START YOUR BUSINESS QUICKLY WITH VERIA HUB'S PROVEN WEB3 SOLUTION. WE PROVIDE EVERYTHING YOU NEED, INCLUDING APIS, SMART CONTRACTS, DASHBOARD ETC</div>
              <div className="first-card-wrapper">
                <div className="first-card">
                  <div className="first-card-title">REALTIME</div>
                  <div className="first-card-description">EXPERIENCE THE HIGHEST SPEED OF BLOCKCHAIN IN REAL-TIME</div>
                </div>
                <div className="first-card middle">
                  <div className="first-card-title">DATA</div>
                  <div className="first-card-description">LEVERAGE USAGE DATA FOR YOUR BUSINESS WITH FULL TRANSPARENCY</div>
                </div>
                <div className="first-card">
                  <div className="first-card-title">ANALYSIS</div>
                  <div className="first-card-description">ANALYZE ON-CHAIN DATA EASILY AND QUICKLY</div>
                </div>
              </div>
              <img className="first-img-wrapper" src={firstImg} alt={''}/>

            </div>
          </div>
        </div>
        <BottomSection title={'RUN YOUR WEB3 BUSINESS WITH VERIA EXPLORER'} description={'CUSTOMIZED SOLUTIONS AND VARIOUS SUPPORT FOR ENTERPRISES'} cardText={'VERIA HUB COLLABORATES WITH GLOBAL ENTERPRISES TO PROMOTE WEB3 ADOPTION AND BLOCKCHAIN COMMERCIALIZATION. WE PROVIDE VARIOUS BLOCKCHAIN-BASED SOLUTIONS INCLUDING STO, WEB3 PAYMENTS, POINTS, AND VOUCHERS, AND WELCOME NEW PARTNERSHIPS.'}/>
        <Footer/>
      </div>
  );
}

export default Explorer;